import { sessionConfig } from 'utils/constant';
import { getAccessToken, axios } from 'utils/common';

class CommonService {
  uploadFile(data) {
    const URL = `Files/upload`;

    const { formData = '' } = data;

    let headers = {
      'Content-Type': 'multipart/form-data'
    };

    const user = JSON.parse(localStorage.getItem(sessionConfig.userData));
    if (user && user.accessToken) {
      headers = {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${getAccessToken()}`
      };
    }

    return axios({
      method: 'post',
      url: URL,
      data: formData,
      headers: headers
    });
  }

  openFile(params) {
    const { ComFileGuid = '' } = params;

    const URL = `Files/${ComFileGuid}`;

    return axios({
      method: 'get',
      url: URL,
      responseType: 'blob'
    });
  }
}
export default new CommonService();
